import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter, Link } from 'react-router-dom';
import { toRenderProps, withState } from 'recompose';
import { withStyles, AppBar, Toolbar, Popover, IconButton } from '@material-ui/core';
import { Apps as AppIcon, ExitToApp as ExitToAppIcon } from '@material-ui/icons';
import { MiddleStatus } from 'data/components';
import { Logger, icons, Toastr } from 'data/common';
import { logOutUser } from 'data/user/actions';
import environments from '../../environments';

const WithState = toRenderProps(withState('anchorEl', 'updateAnchorEl', null));

class Index extends PureComponent {
    static propTypes = {
        environment: PropTypes.string.isRequired,
        history: PropTypes.object.isRequired,
        logOutUser: PropTypes.func.isRequired,
        mainRoutes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        middle: PropTypes.object
    };
    static defaultProps = {
        middle: {}
    };

    _handleDisconnect = () => {
        const { logOutUser, history } = this.props;
        Toastr.confirm(Translator.translate('general.logout.confirmationText'), Translator.translate('general.logout.confirmationTitle'), {
            onYes: () => {
                logOutUser();
                return history.push('/login');
            }
        });
    };

    _renderItems(userEnvironments) {
        const { classes, profile } = this.props;
        let res = [];
        userEnvironments.map((obj, env) => {
            const routes = obj.path;
            let route = null;
            if (Array.isArray(routes)) {
                for (let aRoute of routes) {
                    if (!route && (profile.get('admin') || profile.getIn(['user_rights', 'logging'], []).includes(aRoute.right))) route = aRoute.path;
                }
            } else {
                route = routes;
            }
            if (!route) {
                return null;
            }
            res.push(
                <Link to={route} role="presentation" className={classes.iconContainer} key={route}>
                    <img className={`${classes.iconReflexion} _iconReflexion`} src={icons.reflexion} alt={env} />
                    <img className={`${classes.icon} _icon`} src={icons[env]} alt={env} />
                    <img className={`${classes.shadow} _shadow`} src={icons.shadow} alt="shadow" />
                    <div className={`${classes.menuBarTooltip} _menuBarTooltip`}>{Translator.translate(`${env}.menuItem`).toUpperCase()}</div>
                </Link>
            );
        });
        return res;
    }

    _renderAdminMenu(adminRoutes) {
        const { classes } = this.props;
        let res = [];
        adminRoutes.map(route => {
            res.push(
                <Link to={route.path} role="presentation" className={classes.iconContainer} key={route.path}>
                    <img className={`${classes.iconReflexion} _iconReflexion`} src={icons.reflexion} alt="reflexion" />
                    <img className={`${classes.icon} _icon`} src={icons[route.name]} alt={route.name} />
                    <img className={`${classes.shadow} _shadow`} src={icons.shadow} alt="shadow" />
                    <div className={`${classes.menuBarTooltip} _menuBarTooltip`}>
                        {Translator.translate(`general.${route.name}.menuItem`).toUpperCase()}
                    </div>
                </Link>
            );
        });
        return res;
    }

    _renderLogOut() {
        const { classes } = this.props;
        return (
            <div className={classes.iconContainer} key="logout" onClick={this._handleDisconnect} role="presentation">
                <img className={`${classes.iconReflexion} _iconReflexion`} src={icons.reflexion} alt="reflexion" />
                <img className={`${classes.icon} _icon`} src={icons['logout']} alt="logout" />
                <img className={`${classes.shadow} _shadow`} src={icons.shadow} alt="logout" />
                <div className={`${classes.menuBarTooltip} _menuBarTooltip`}>{Translator.translate(`general.logout.tooltip`).toUpperCase()}</div>
            </div>
        );
    }

    renderMiddlewareState = () => {
        const { middle } = this.props;
        if (!middle || middle.size === 0 || (middle.size === 1 && !middle.first().get('state'))) return null;
        if (middle.size === 1) {
            return <MiddleStatus middleState={middle.first().get('state')} />;
        }

        let popoverMiddle = [];
        middle.map((midObj, mid) => {
            popoverMiddle.push(<MiddleStatus key={mid} middleName={midObj.get('label')} middleState={midObj.get('state')} />);
        });
        return (
            <WithState>
                {({ anchorEl, updateAnchorEl }) => {
                    const open = Boolean(anchorEl);
                    return (
                        <Fragment>
                            <IconButton
                                aria-owns={open ? 'render-props-popover' : undefined}
                                aria-haspopup="true"
                                variant="contained"
                                onClick={event => {
                                    updateAnchorEl(event.currentTarget);
                                }}
                            >
                                <MiddleStatus
                                    middleState={
                                        middle.find(mid => mid.get('state') === 'disconnected' || mid.get('state') === 'pending')
                                            ? 'disconnected'
                                            : 'connected'
                                    }
                                />
                            </IconButton>
                            <Popover
                                id="render-props-popover"
                                open={open}
                                anchorEl={anchorEl}
                                onClose={() => {
                                    updateAnchorEl(null);
                                }}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right'
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                            >
                                {popoverMiddle}
                            </Popover>
                        </Fragment>
                    );
                }}
            </WithState>
        );
    };

    render() {
        const { environment, profile, theme, mainRoutes, classes } = this.props;
        const userEnvironments = environments
            .getEnvironments()
            .filter((route, env) => {
                if (profile.get('admin')) return true;
                return profile.get('environments') && profile.get('environments').indexOf(env) !== -1;
            })
            .sortBy(env => env.index);

        const adminRoutes = mainRoutes.filter(route => {
            return route.admin;
        });

        let items = this._renderItems(userEnvironments);
        if (profile.get('admin')) items.push(this._renderAdminMenu(adminRoutes));

        const hasMenu = items.length > 1;
        items.push(this._renderLogOut());

        return (
            <div className={classes.menuBarContainer}>
                <AppBar>
                    <Toolbar>
                        <Link to="/menu" role="presentation" className={`${classes.menuBarIconContainer} ${!hasMenu ? classes.disableLink : ''}`}>
                            <img className={classes.menuBarIcon} src={icons[environment]} alt="icon" />
                            <img className={classes.menuBarIconShadow} src={icons.shadow} alt="shadow" />
                        </Link>
                        <div className={classes.menuBarTitle}>{Translator.translate(`${environment}.menuItem`).toUpperCase()}</div>
                        <WithState>
                            {({ anchorEl, updateAnchorEl }) => {
                                const open = Boolean(anchorEl);
                                return (
                                    <div className={classes.menuBarActionContainer}>
                                        {this.renderMiddlewareState()}
                                        {!hasMenu ? (
                                            <IconButton variant="contained" onClick={this._handleDisconnect}>
                                                <ExitToAppIcon />
                                            </IconButton>
                                        ) : (
                                            <Fragment>
                                                <IconButton
                                                    className={classes.iconButtonMenu}
                                                    aria-owns={open ? 'render-props-popover' : undefined}
                                                    aria-haspopup="true"
                                                    variant="contained"
                                                    onClick={event => {
                                                        updateAnchorEl(event.currentTarget);
                                                    }}
                                                >
                                                    <AppIcon />
                                                </IconButton>
                                                <Popover
                                                    id="render-props-popover"
                                                    open={open}
                                                    anchorEl={anchorEl}
                                                    onClose={() => {
                                                        updateAnchorEl(null);
                                                    }}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'center'
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'center'
                                                    }}
                                                >
                                                    <div
                                                        className={classes.propoverContent}
                                                        style={{ backgroundColor: theme.palette.background.paper }}
                                                    >
                                                        {items}
                                                    </div>
                                                </Popover>
                                            </Fragment>
                                        )}
                                    </div>
                                );
                            }}
                        </WithState>
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    let middle = null;
    if (state.environments.hasOwnProperty(props.environment) && state.environments[props.environment].middleware !== undefined)
        middle = state.environments[props.environment].middleware;
    return {
        profile: state.data.user,
        middle
    };
}

const styles = theme => ({
    iconButtonMenu: {
        color: theme.palette.background.paper
    },
    disableLink: {
        pointerEvents: 'none'
    },
    menuBarContainer: {
        width: '100%',
        top: 0,
        position: 'fixed',
        height: 64,
        zIndex: 20
    },
    menuBarIcon: {
        cursor: 'pointer',
        width: 45,
        height: 45,
        position: 'absolute',
        zIndex: 2
    },
    menuBarIconShadow: {
        width: 48,
        height: 48,
        position: 'relative',
        zIndex: 1
    },
    menuBarTitle: {
        flexGrow: 1,
        fontSize: '1.6em',
        fontWeight: 500,
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.background.paper,
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.4em',
            lineHeight: 1.2
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2em',
            lineHeight: 1.2
        }
    },
    menuBarActionContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    menuBarIconContainer: {
        position: 'relative',
        left: 0,
        marginRight: 20
    },
    propoverContent: {
        padding: 15,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        width: 400,
        maxHeight: 500
    },
    iconContainer: {
        display: 'flex',
        width: 50,
        height: 50,
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        margin: '25px 20px',
        fontSize: '0.7em',
        '&:hover': {
            cursor: 'pointer',
            '& ._icon': {
                transition: 'all 0.2s ease-in-out',
                transform: 'translate(0, -0.2em)'
            },
            '& ._shadow': {
                transition: 'all 0.2s ease-in-out',
                transform: 'translate(0, -0.1em)',
                width: 64,
                height: 64,
                opacity: 0.3
            },
            '& ._iconReflexion': {
                transition: 'all 0.2s ease-in-out',
                transform: 'translate(0, -0.1em)',
                opacity: 0
            },
            '& ._menuBarTooltip': {
                transition: 'all 0.2s ease-in-out',
                opacity: 100,
                top: 55
            }
        }
    },
    menuBarTooltip: {
        transition: 'all 0.2s ease-in-out',
        opacity: 0,
        top: 0,
        position: 'absolute',
        width: 'auto',
        margin: '0 auto',
        textAlign: 'center'
    },
    icon: {
        transition: 'all 0.2s ease-in-out',
        position: 'absolute',
        width: 60,
        height: 60,
        zIndex: 1
    },
    shadow: {
        boxShadow: 'none',
        transition: 'all 0.2s ease-in-out',
        position: 'absolute',
        zIndex: 0,
        width: 63,
        height: 63
    },
    iconReflexion: {
        transition: 'all 0.2s ease-in-out',
        position: 'absolute',
        width: 60,
        height: 60,
        zIndex: 3,
        opacity: 0.3
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { logOutUser }), dispatch)
    )(withStyles(styles, { withTheme: true })(Index))
);



// WEBPACK FOOTER //
// ./data/components/MenuBar.js